<style src="./styles/global.scss" lang="scss"></style>

<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    this.$http.get('/static/questions/questions_config.json').then(response => {
      this.$store.dispatch('setAllQuestions', response.body)

      // parse query params
      let query = this.$route.query
      this.$store.dispatch('setDisplayConfig', (query.display_config !== '0'))
      this.$store.dispatch('setPresentationMode', ((query.presentation_mode === '1')))

      let lang = (query.lang === 'de') ? 'de' : 'en'
      this.$store.dispatch('setLanguage', lang)
      this.$i18n.locale = lang

      let selectedTopics = (query.selected_topics) ? JSON.parse(query.selected_topics) : this.$store.getters.getAllTopics

      // based on that intialize config
      this.$store.dispatch('setSelectedTopics', selectedTopics)
      this.$store.dispatch('setSelectedQuestions')
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue